import rp, { CodeEditorAdapter, CodeEditor } from "@reporting/rp-app-host";
import { SsoOidcParams } from "@reporting/rp-types/accounting";

/**
 * The secret part of a group's OpenID Connect configuration - the client secret and the settings
 * JSON - read and written through /ssoOidcParams (full group admins only).
 */
export class SsoOidcParamCodeEditorAdapter extends CodeEditorAdapter<CodeEditor> {

	constructor(
		private g: number,
		private type: 'client_secret' | 'settings',
	) { super() }

	async getContent(): Promise<string> {
		const params = await rp.ms('accounting').get<SsoOidcParams>('ssoOidcParams');
		return params[this.type as keyof SsoOidcParams] as string || '';
	}

	async save(value: string) {
		const data: SsoOidcParams = {
			id_group: this.g,
			[this.type]: value
		};
		await rp.ms('accounting').post(`ssoOidcParams`, data);
	}

}
